import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { UpdateQueryParams, usePrevious } from '@hooks';

export type DisplayNameFilterParams = { objectNameFilter?: string };

export interface DisplayNameFilterProps {
	disabled?: boolean;
	value?: string;
	onChange: UpdateQueryParams<DisplayNameFilterParams>;
}

export const DisplayNameFilter: React.FC<DisplayNameFilterProps> = ({ disabled, value = '', onChange }) => {
	const [ displayName, setDisplayName ] = useState(value);
	const previousValue = usePrevious(value);

	const handleOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setDisplayName(e.target.value);
	}, []);

	const handleOnSearch = useCallback(() => {
		onChange({ objectNameFilter: displayName });
	}, [ displayName, onChange ]);

	useEffect(() => {
		if (displayName && previousValue && !value) {
			setDisplayName('');
		}
	}, [ displayName, previousValue, value ]);

	return <Input.Search
		allowClear
		className='display-name-filter'
		disabled={ disabled }
		onBlur={ handleOnSearch }
		onChange={ handleOnChange }
		onPressEnter={ handleOnSearch }
		onSearch={ handleOnSearch }
		placeholder={ COPY_SPECIFIC.DISPLAY_NAME }
		value={ displayName } />;
};
